const rankings = [
  { rank: 1, title: '夏日冒险物语', type: '电影', tag: '新上榜', hot: '本周播放量 128.6万' },
  { rank: 2, title: '都市夜未央', type: '电视剧', tag: '热播中', hot: '本周播放量 115.3万' },
  { rank: 3, title: '星际征途：重启', type: '动漫', tag: '飙升', hot: '本周播放量 98.7万' },
  { rank: 4, title: '欢乐事务所', type: '综艺', tag: '', hot: '本周播放量 87.2万' },
  { rank: 5, title: '山河万里行', type: '纪录片', tag: '', hot: '本周播放量 72.5万' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热度排行
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            本周最受欢迎的影视内容排行榜
          </p>
        </div>
        <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
          {rankings.map((item, i) => {
            const medalColors = [
              'text-accent-500',
              'text-secondary-400',
              'text-primary-600',
            ];
            const medalIcons = [
              'ri-medal-fill',
              'ri-medal-fill',
              'ri-medal-fill',
            ];

            return (
              <div
                key={i}
                className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 md:py-5 ${
                  i < rankings.length - 1 ? 'border-b border-background-200/50' : ''
                } hover:bg-background-100 transition-colors cursor-pointer`}
              >
                <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center font-heading font-bold text-lg ${
                  i < 3 ? medalColors[i] : 'text-foreground-400'
                }`}>
                  {i < 3 ? (
                    <i className={`${medalIcons[i]} text-xl`}></i>
                  ) : (
                    <span className="text-sm">{item.rank}</span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm md:text-base font-medium text-foreground-950 truncate">
                      {item.title}
                    </span>
                    <span className="text-xs text-foreground-500 bg-background-200 px-1.5 py-0.5 rounded whitespace-nowrap">
                      {item.type}
                    </span>
                    {item.tag && (
                      <span className={`text-xs px-1.5 py-0.5 rounded whitespace-nowrap ${
                        item.tag === '飙升'
                          ? 'bg-primary-100 text-primary-700'
                          : item.tag === '新上榜'
                          ? 'bg-accent-100 text-accent-800'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}>
                        {item.tag}
                      </span>
                    )}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{item.hot}</div>
                </div>
                <a
                  href="#cards"
                  className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg bg-background-100 hover:bg-primary-100 text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-s-line"></i>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}